import { render } from "./ResidencesComponent.vue?vue&type=template&id=f5caf462&scoped=true"
import script from "./ResidencesComponent.vue?vue&type=script&lang=js"
export * from "./ResidencesComponent.vue?vue&type=script&lang=js"

import "./ResidencesComponent.vue?vue&type=style&index=0&id=f5caf462&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5caf462"]])

export default __exports__